// extracted by mini-css-extract-plugin
export default {"whatIs":"WhatIs_whatIs__23+GN","blocks":"WhatIs_blocks__+ssZi"};